import API from 'services/TAPS_API';

export default function getRegions() {
  return API.request({
    method: 'GET',
    url: `/dictionary/region`,
  });
}
